import controller from './icon.controller';

const template = require('./icon.html');

export default {
    bindings: {
        iconClass: '<',
        colorClass: '<',
        hasExclamation: '<',
        iconSize: '@',
        showAriaLabel: '<'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/common/icon/icon.component.js